<template>
  <div class="contenido pa-6">
    <v-row justify="center">
      <v-col cols="10">
        <v-alert
          :value="true"
          color="error"
          dense
          outlined
          icon="mdi-information"
          >Está en periodo de consolidación de notas de alumnos, de no conocer a
          lo que esto se refiere por favor contáctese con algún Administrador.
          Gracias !!!</v-alert
        >
        <h1>Mis Grados/Cursos</h1>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">Atención...!!!</v-card-title>
        <v-card-text>No puede ingresar una nota superior a '10.00'</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row row wrap justify="center" v-if="this.materiasCant > 0">
      <template v-for="materia in materias">
        <v-col md="auto" :key="materia.idMateria">
          <v-btn
            color="success"
            @click="
              obtenerNotasDeMateriaBtn(
                materia.idMateria,
                materia.nombre,
                materia.agrupamiento
              )
            "
            >{{ materia.nombre }} {{ materia.agrupamiento }}</v-btn
          >
        </v-col>
      </template>
    </v-row>

    <div justify="start" class="titulo">
      <h2>{{ materiaSeleccionadaNombre }}</h2>
    </div>

    <div v-if="mostrarNotas">
      <v-row align="center" justify="end" fill-height no-gutters>
        <v-col md="auto">
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
            fab
            @click="descargarPDF"
          >
            <v-icon dark>mdi-cloud-download</v-icon>
          </v-btn>
        </v-col>
        <v-col md="auto" class="pr-2">
          <v-switch v-model="switch1" label="Editar"></v-switch>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="2" class="text-center colorHeaders"></v-col>
        <v-col cols="9" class="padding_right">
          <v-row no-gutters>
            <v-col
              v-for="termino in headers"
              :key="termino.grupoID"
              class="text-center colorHeaders"
              v-bind:class="[
                termino.descripcion_grupo == 'examenes' ? 'ocultarHeader' : '',
              ]"
              >{{ mayusculas(termino.descripcion_grupo) }}</v-col
            >
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="2" class="text-center colorHeaders"
          >Apellido(s) y Nombre(s)</v-col
        >
        <v-col cols="9">
          <v-row no-gutters>
            <v-col
              cols="3"
              v-for="grupo in headers"
              :key="grupo.grupoID"
              class="borde-grupo-notas"
            >
              <v-row justify="center" no-gutters>
                <v-col
                  cols="4"
                  v-if="grupo.descripcion_grupo == 'examenes'"
                  class="text-center font_size_11px"
                  >Promedio Anual</v-col
                >
                <v-col
                  v-bind:class="[
                    grupo.descripcion_grupo == 'examenes'
                      ? 'cols=\'4\''
                      : 'cols=\'2\'',
                  ]"
                  v-for="item in grupo.notas"
                  :key="item.id"
                  class="text-center font_size_11px"
                  >{{ item.descripcion_nota }}</v-col
                >
                <v-col
                  cols="2"
                  class="text-center textoCentrado font_size_11px"
                  v-if="grupo.verPromedio != '0'"
                  >Prom</v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" class="text-center font_size_11px"
          >Calicación Definitiva</v-col
        >
        <!--<div class="columna_espacio"></div>-->
      </v-row>
      <v-row v-if="alumnos.length > 0" no-gutters>
        <v-col cols="12">
          <template v-for="alumno in alumnos">
            <alumno
              :key="alumno.idAlumno"
              :idalumno="alumno.idAlumno"
              :nota_consolidada="alumno.nota_final"
              :nombreAlumno="alumno.nombre_alumno"
              :apellidoAlumno="alumno.apellido_alumno"
              :gruposNotas="alumno.grupos"
              :materia="materiaSeleccionada"
              :alumnoRegular="alumno.regular"
              :habilitarEdicion="switch1"
              :permisoEdicion="true"
              @itemAlumno:recargarNotas="recargarNotas"
              @itemAlumno:mostrarMsjNotaInvalida="mostrarMsjNotaInvalida"
            />
          </template>
        </v-col>
      </v-row>
    </div>
    <div v-else class="notificacion" justify="center">{{ msj }}</div>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import alumno from "./itemAlumno";

export default {
  data() {
    return {
      dialog: false,
      materias: [],
      materiasCant: "",
      mostrarNotas: false,
      switch1: false,
      headers: [],
      alumnos: [],
      msj: "",
      idProfesor: "",
      materiaSeleccionada: "",
      materiaSeleccionadaNombre: "",
    };
  },
  components: {
    alumno,
  },
  mounted: function () {
    //API.enRangoDeFechas("2019-03-01 00:00:00", "2019-05-12 00:00:00");
    let datosUsuario = window.localStorage.getItem("EPA_AUTH");

    if (datosUsuario != null) {
      try {
        var usuarioJson = JSON.parse(datosUsuario);
        this.idProfesor = usuarioJson.idProfesor;
      } catch (err) {
        //console.log("catch idProfesor vistaPrincipal Docente ->mounted: ", err);
        window.localStorage.removeItem("EPA_AUTH");
      }
    }

    let params = "idProfesor=" + this.idProfesor;
    let resultado = API.enviar("get", "obtenerMateriasDeProfesor", params);

    resultado
      .then((result) => {
        this.materias = result.data;
        this.materiasCant = result.data.length;
      })
      .catch((error) => {
        console.log("CATCH DOCENTE obtenerMateriasDeProfesor-> error: ", error);
      });
  },
  computed: {},
  methods: {
    mayusculas: function (string) {
      let string_aux = API.ucFirst(string);
      return string_aux;
    },
    obtenerHeaders: function () {
      let headersGrupos = [];
      let primerAlumno = this.alumnos[0];

      for (const obj in primerAlumno.grupos) {
        headersGrupos.push(primerAlumno.grupos[obj]);
      }

      this.headers = headersGrupos;
    },
    obtenerNotasDeMateria: function (
      idMateriaAgrupamiento,
      meteria,
      agrupamiento
    ) {
      // titulo de la materia seleccionada
      if (meteria != undefined && agrupamiento != undefined) {
        //this.$emit("notasMaterias:mostrarOcultarPreload");
        let nombre_materia = meteria + " > " + agrupamiento.toLocaleUpperCase();
        //pep.charAt().toLocaleUpperCase() + pep.substring(1, pep.length)
        //console.log(nombre_materia);
        this.materiaSeleccionadaNombre =
          nombre_materia.charAt().toLocaleUpperCase() +
          nombre_materia.substring(1, nombre_materia.length);
      }
      // Edicion de materias false
      //this.switch1 = false;

      this.materiaSeleccionada = idMateriaAgrupamiento;
      this.msj = "";

      let params = "idMateria=" + idMateriaAgrupamiento;
      let resultado = API.enviar("get", "obtenerNotasMateria", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") {
            this.alumnos = result.data.result;
            this.mostrarNotas = true;
            this.obtenerHeaders();
            //console.log(this.alumnos.length);
          } else {
            this.mostrarNotas = false;
            this.msj = result.data.msj;
          }
          this.$emit("notasMaterias:mostrarOcultarPreload", false);
        })
        .catch(() => {
          this.$emit("notasMaterias:mostrarOcultarPreload", false);
        });
    },
    recargarNotas: function () {
      this.obtenerNotasDeMateria(this.materiaSeleccionada);
    },
    mostrarMsjNotaInvalida: function () {
      this.dialog = true;
      this.recargarNotas();
    },
    deshabilitarEdicionNotas: function () {
      this.switch1 = false;
    },
    obtenerNotasDeMateriaBtn: function (
      idMateria,
      nombreMateria,
      agrupamiento
    ) {
      this.$emit("notasMaterias:mostrarOcultarPreload", true);
      this.deshabilitarEdicionNotas();
      this.obtenerNotasDeMateria(idMateria, nombreMateria, agrupamiento);
    },
    descargarPDF: function () {
      /*let nombreMateria = this.materiaSeleccionadaNombre.split(">")[0];
      let agrupamiento = this.materiaSeleccionadaNombre.split(">")[1];
      let token = '';
      let local = window.localStorage.getItem("EPA_AUTH");

      if (local != null) {
        let localJson = JSON.parse(local);
        token = localJson.token;
      }

      window.open(
        API.PORT +
          API.PATH +
          "?funcion=descargarReporteNotasMateria&idMateria=" +
          this.materiaSeleccionada +
          "&nombreMateria=" +
          nombreMateria +
          "&agrupamiento=" +
          agrupamiento +
          "&token=" +
          token
      );*/

      console.log(this.headers);
      console.log("------------------------------------------------");
      console.log(this.alumnos);
    },
  },
};
</script>

<style>
h1 {
  text-align: center;
  padding: 15px 0 15px 0;
}

.notificacion {
  text-align: center;
  /*padding-top: 25px;*/
}

.titulo {
  padding-top: 25px;
  text-align: left;
}

.contenido {
  width: 100% !important;
}

.colorHeaders {
  color: #fff;
  font-weight: bold;
  background-color: #4caf50;
  opacity: 0.7;
  margin: 2px;

  /*padding-left: 5px;*/
}

.padding_right {
  padding-right: 40px;
}

.borde-grupo-notas {
  border-right: solid 2px rgba(76, 174, 79, 0.7);
}

.ocultarHeader {
  visibility: hidden;
}

.iconoDescargar {
  padding-right: 10px;
  padding-bottom: 5px;
  cursor: pointer;
}

.font_size_11px {
  font-size: 11px;
}

.columna_espacio {
  width: 25px;
}

.col {
  margin: 0px !important;
}
</style>